import type { GnbInfo, GnbResponse } from '~/types/display/gnb-type'

export function useShopGnbTransform() {
  const convertResponse = (
    data: GnbResponse,
  ): GnbInfo[] | null => {
    // 데이터 없는 경우 캐시 미적용
    if (!data?.payload || data?.payload?.length === 0)
      return null

    return data.payload
  }
  return {
    convertResponse,
  }
}
